export const headerMap = {
    id: "Id Propiedad",
    users_id: "Id Usuario",
    user_frequency: "Frecuencia de Usuario",
    email: "Email",
    phone_contact: "Número de Contacto",
    median_days: "Median days",
    feed_name: "Feed name",
    zone_classification: "Clasificación de zona",
    broker_type: "Broker Type",
    size_house: "Área",
    sale_price: "Precio",
    type: "Tipo de Propiedad",
    age: "Antiguedad",
    city: "Ciudad",
    status: "Estado",
    sepomex_id: "Sepomex ID",
    colony: "Colony",
    zipcode: "Zip Code",
    street: "Dirección",
    hide_external_num: "Ocultar número externo",
    external_num: "Número externo",
    hide_internal_num: "Ocultar número interno",
    internal_num: "Número interno",
    type_children: "Tipo",
    full_address: "Dirección completa",
    publish_date: "Fecha de publicación",
    updated_at: "Fecha de Actualización",
    property_exported: "Property Exported",
    user_exported: "Usuario",
    is_interested: "Está interesado",
    export_date: "Fecha de Publicación",
    in_range_price: "En rango de precio",
    is_price_negotiable: "Precio negociable",
    num_comparable: "Número de comparables",
    offer_from_whatsapp: "Contactable"
};

export const filterMap = {
    "city_id": "Ciudad id",
    "date_end": "Fecha fin",
    "date_init": "Fecha inicial",
    "price_max": "Precio máximo",
    "price_min": "Precio minimo",
    "broker_type": "Tipo de broker",
    "leads_count": 'Cantidad leads',
    "is_interested": "Interesado",
    "user_exported": "Usuario",
    "property_exported": "Propiedad exportada",
    "offer_from_whatsapp": "Contactable",
    "in_range_price": "Está en rango de precio",
    "num_comparable": "Comparables",
    "is_price_negotiable": "Precio negociable",
    "zone_classification": "Clasificación de zona",
    "from_xml": "Feed name"
};